/**
 * Animated circle behind player seats — Calling Pro badge or Admin AI hold.
 */
import { getCallingPro, adminHeldProForSeat, type CallingPro } from "@shared/calling-pros";

export function ProBadgeRing({
  proId,
  seatIndex = 0,
  size = 44,
  /** true = show Admin AI held icon (not yet claimed by a pro) */
  adminHold = false,
  claimed = false,
  className = "",
}: {
  proId?: string | null;
  seatIndex?: number;
  size?: number;
  adminHold?: boolean;
  claimed?: boolean;
  className?: string;
}) {
  const pro: CallingPro | undefined = claimed
    ? getCallingPro(proId)
    : adminHold
      ? adminHeldProForSeat(seatIndex)
      : getCallingPro(proId);

  if (!pro && !adminHold) return null;

  const icon = pro?.icon;
  const isHeld = adminHold && !claimed;

  return (
    <div
      className={`pro-badge-ring ${isHeld ? "pro-badge-ring--held" : "pro-badge-ring--claimed"} ${className}`}
      style={{ width: size, height: size }}
      title={
        isHeld
          ? `${pro?.name ?? "Pro"} · held by Admin AI`
          : `${pro?.name ?? "Pro"} · claimed badge`
      }
    >
      <span className="pro-badge-ring__spin" aria-hidden />
      <span className="pro-badge-ring__glow" aria-hidden />
      {icon && (
        <img
          src={icon}
          alt=""
          className="pro-badge-ring__icon"
          draggable={false}
        />
      )}
      {isHeld && <span className="pro-badge-ring__ai">AI</span>}
    </div>
  );
}
